import React from "react";
import styled from "styled-components";
import { Redirect } from "react-router-dom";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #ff0000;
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  font-size: 36px;

  color: #fff;
`;

const NoMatch = props => {
  return [<Wrapper>404 ...</Wrapper>, <Redirect to="/" />];
};

export default NoMatch;
